import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Form } from 'antd';
import { LayersComparisonNodeModel } from '../../models';
import { useNodeComparisonForm } from '../../hooks';
import { ContractComparisonPanelsRenderer } from '..';
import './LayersComparisonRenderer.less';

interface Props {
    comparisonNode: LayersComparisonNodeModel;
}

const LayersComparisonRenderer: React.FC<Props> = ({ comparisonNode }) => {
    const { form, formKey, onValuesChange } = useNodeComparisonForm(
        comparisonNode.newNode,
        comparisonNode.previousNode
    );

    return (
        <div className="layers-comparison-renderer">
            <Form id={comparisonNode.nodeId} key={formKey} form={form} onValuesChange={onValuesChange}>
                <div className="layers-comparison-panels-container">
                    <ContractComparisonPanelsRenderer comparisonNode={comparisonNode} />
                </div>
            </Form>
        </div>
    );
};

export default observer(LayersComparisonRenderer);
